<template>
    <el-row :gutter="30">
        <el-col :xs="24" :xl="16">
            <el-form-item prop="realNameValidType" :rules="[{required: true, message: `请选择至少1项实名认证方式`}]">
                <el-radio-group v-model="formData.realNameValidType" size="medium"  :disabled="channelName && channelName != 'showstart' ">
                    <el-radio :label="1">证件二要素认证</el-radio>
                    <el-radio :label="2">身份证人脸认证</el-radio>
                    <el-radio :label="0">无须认证</el-radio>
                </el-radio-group>
            </el-form-item>		
        </el-col>
    </el-row>
</template>

<script>
export default {
    props:{
        formData: {
            type: Object,
            default: null
        },
		channelName:{
			type:[Number,String],
			default:''
		}
    },
	
}
</script>

<style lang="scss" scoped>

</style>